import React from "react";
import xBullRunLogo from "./../../../assets/x-bull-run.png";

const FooterLogo = () => {
	return (
		<div className="mb-4 px-6 pb-3 sm:hidden">
			<img
				src={xBullRunLogo}
				width={"149px"}
				height={"51px"}
				alt="XBullRun logo"
			/>
		</div>
	);
};

export default FooterLogo;
